export default __webpack_public_path__ + "static/media/Paint Mixer.9abadf5c.jpg";